import { render, staticRenderFns } from "./PropertyMenuComponent.vue?vue&type=template&id=f5b8bd78"
import script from "./PropertyMenuComponent.vue?vue&type=script&lang=js"
export * from "./PropertyMenuComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports